import ShoppingCartOutlined from '@ant-design/icons/ShoppingCartOutlined';
import CompassOutlined from '@ant-design/icons/CompassOutlined';
import { t } from 'i18n';

const orders = {
  id: 'group-orders',
  title: t('Orders & Dispatch'),
  type: 'group',
  children: [
    { id: 'orders-list', title: t('Orders'), type: 'item', url: '/orders', icon: ShoppingCartOutlined },
    { id: 'trips', title: t('Trips'), type: 'item', url: '/orders/trips', icon: CompassOutlined }
  ]
};

export default orders;
